import { ImageColorFinderFlight, VideoColorFinderFlight } from "@nova/protobuf"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { getStartPosition } from "plugins/ColorFinder/V2/ColorFinderQueries"
import { openColorFinder } from "plugins/ColorFinder/V2/redux/slice"
import { PluginSpec, staticIcon } from "plugins/plugin-registry"
import { useMemo } from "react"

export const getUseColorfinderMapNodes = <
    T extends ImageColorFinderFlight | VideoColorFinderFlight,
>(
    spec: PluginSpec<T>
) => {
    const useColorfinderMapNodes = () => {
        const dispatch = useAppDispatch()
        const entities = useAppSelector(spec.selectAllEntities)
        const entityData = useMemo(() => {
            return entities
                .filter((entity) => {
                    const position = getStartPosition(entity)
                    return !entity.archivedTimestamp && position
                })
                .map((entity) => {
                    const position = getStartPosition(entity)!
                    return {
                        id: entity.id,
                        position: {
                            lat: position[1],
                            lng: position[0],
                        },
                        visible: entity.visible,
                        locked: !!entity.locked,
                        active: false,
                        onClick: () => {
                            dispatch(openColorFinder({ flightId: entity.id }))
                        },
                        iconSrc: staticIcon({
                            default: "/icons/colorfinder/default.svg",
                            hover: "/icons/colorfinder/hover.svg",
                        }),
                    }
                })
        }, [dispatch, entities])
        return entityData
    }
    return useColorfinderMapNodes
}
